import * as React from "react";
const SvgStore20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M16.33 1.667H3.663v1.9H16.33v-1.9Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17.173 4.167H2.82L.83 10.832h1.267v7.5H17.93v-7.5h1.233l-1.99-6.667Zm-13.41 6.666h.867V15.8h7.6v-4.967h1.267v5.833H3.763v-5.833Zm12.5 5.833h-1.1V12.4h1.1v4.266Zm-5.7-4.266H6.297v1.733h4.266V12.4Z",
      clipRule: "evenodd"
    })
  );
export default SvgStore20Px;
